import UtilService from "../../../helper/service";
import { ADD_COMPARE_DATA, UPDATE_COMPARE_DATA, REMOVE_COMPARE_PATH, ADD_COMPARE_PATH, UPDATE_TABLE_SORT_COMPARE, INITIALIZE_SORTING_COMPARE } from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  compareData: [],
  path: null, // dashboard, clip,
  sortKey: 'immersion',
  sortType: 'desc',
  sortImmersion: true,
}

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_COMPARE_DATA:
      const session_id = action.payload.session_id;
      const oldCompareData: any = state.compareData;

      let targetIndex = -1;

      oldCompareData.map((item: any, index: number) => {
        if (String(item.session_id) === String(session_id)) targetIndex = index;
      });

      if (targetIndex !== -1) {
        oldCompareData[targetIndex] = action.payload;
      }

      return updateObject(state, {
        compareData: oldCompareData
      });

    case ADD_COMPARE_DATA:
      return updateObject(state, {
        compareData: [...state.compareData, action.payload]
      });

    case ADD_COMPARE_PATH:
      return updateObject(state, {
        path: action.payload
      });

    case REMOVE_COMPARE_PATH:
      return updateObject(state, {
        path: null
      });

    case UPDATE_TABLE_SORT_COMPARE:
      const data = action.payload;
      const sortType = (UtilService.compareSortLabel(data) === state.sortKey) ? ((state.sortType === 'desc') ? 'asc' : 'desc') : 'desc'
      return updateObject(state, {
        sortKey: UtilService.compareSortLabel(data),
        sortType,
        sortImmersion: data === 'immersion' ? true : data === 'safety' ? false : state.sortImmersion
      });

    case INITIALIZE_SORTING_COMPARE:
      return updateObject(state, {
        sortKey: 'immersion',
        sortType: 'desc',
        sortImmersion: true,
      });

    default:
      return state;
  }
}

export default reducer;